export default __webpack_public_path__ + "static/media/1_topup.1f6900b1.svg";